export default __webpack_public_path__ + "static/media/B.1f6e795c.svg";